/*
 * Berry — « Afficher plus de produits »
 * Scroll infini intelligent qui respecte le footer + prechargement (page + images) en arriere-plan.
 *  Regle 1 : le client s'arrete pres du dernier produit -> bouton + barre 1s -> chargement (instantane car precharge).
 *  Regle 2 : le client file tout en bas de la page -> rien (le footer reste atteignable).
 * Remplace le scroll infini natif d'Horizon. Fallback : la pagination numerotee reste dans le DOM.
 */
(function () {
  var FILL_MS = 1000; // duree de la barre
  var IDLE_MS = 300;  // arret du scroll avant declenchement
  var BOTTOM_GAP = 4; // marge px pour detecter le bas absolu de la page

  if (customElements.get('berry-load-more')) return;

  class BerryLoadMore extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.getAttribute('data-section-id');
      this.btn = this.querySelector('.berry-load-more__btn');
      this.fill = this.querySelector('.berry-load-more__fill');
      this.grid = this.closest('results-list')
        ? this.closest('results-list').querySelector('.product-grid')
        : document.querySelector('.product-grid');

      this.loading = false;
      this.rAF = null;
      this.barStart = null;
      this.idleTimer = null;
      this.pf = null; // { page, sig, promise } page prechargee

      // JS actif -> on masque la pagination numerotee et on utilise le bouton.
      document.documentElement.classList.add('berry-lm-on');

      if (!this.grid) return;

      this.onScroll = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll, { passive: true });

      if (this.btn) {
        this.btn.addEventListener('click', () => { this.stopBar(); this.loadMore(); });
      }

      this.hide();
      // eval une fois + precharge la page suivante en arriere-plan des le depart
      requestAnimationFrame(() => { this.onIdle(); this.prefetchNext(); });
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
      this.stopBar();
      clearTimeout(this.idleTimer);
    }

    lastPage() {
      var lp = this.grid ? parseInt(this.grid.getAttribute('data-last-page'), 10) : 1;
      return lp > 0 ? lp : 1;
    }

    currentPage() {
      var max = 1;
      if (!this.grid) return max;
      var items = this.grid.querySelectorAll('[data-page]');
      for (var i = 0; i < items.length; i++) {
        var p = parseInt(items[i].getAttribute('data-page'), 10);
        if (p > max) max = p;
      }
      return max;
    }

    hasMore() { return this.currentPage() < this.lastPage(); }

    // signature de l'etat courant (filtres/tri) hors page/section_id
    sig() {
      var u = new URL(window.location.href);
      u.searchParams.delete('page');
      u.searchParams.delete('section_id');
      u.searchParams.sort();
      return u.search;
    }

    atBottom() {
      return window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - BOTTOM_GAP;
    }

    lastVisible() {
      var last = this.grid ? this.grid.querySelector('.product-grid__item:last-child') : null;
      if (!last) return false;
      return last.getBoundingClientRect().top < window.innerHeight - 20;
    }

    // recupere et parse une page ; precharge les images ; renvoie un tableau d'elements <li>
    fetchPage(n) {
      var self = this;
      var url = new URL(window.location.href);
      url.searchParams.set('page', String(n));
      url.searchParams.set('section_id', this.sectionId);
      url.searchParams.sort();
      return fetch(url.toString())
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var g = doc.querySelector('[ref=grid]') || doc.querySelector('.product-grid');
          if (!g) return [];
          var arr = Array.prototype.slice.call(g.querySelectorAll(':scope > .product-grid__item'));
          // precharge les images en memoire pendant le prefetch -> cascade fluide, sans pop au scroll
          for (var a = 0; a < arr.length; a++) {
            var imgs = arr[a].querySelectorAll('img');
            for (var b = 0; b < imgs.length; b++) {
              var im = imgs[b];
              im.setAttribute('loading', 'eager');       // ne pas attendre le scroll
              im.removeAttribute('data-src');
              var pre = new Image();
              var ss = im.getAttribute('srcset');
              var sz = im.getAttribute('sizes');
              if (ss) pre.srcset = ss;
              if (sz) pre.sizes = sz;
              var sr = im.getAttribute('src');
              if (sr) pre.src = sr;
            }
          }
          return arr;
        })
        .catch(function () { return []; });
    }

    // precharge la prochaine page en memoire si pas deja fait (ou si les filtres ont change)
    prefetchNext() {
      if (this.loading) return;
      var np = this.currentPage() + 1;
      if (np > this.lastPage()) { this.pf = null; return; }
      var s = this.sig();
      if (this.pf && this.pf.page === np && this.pf.sig === s) return;
      this.pf = { page: np, sig: s, promise: this.fetchPage(np) };
    }

    onScroll() {
      // tout mouvement annule une barre en cours et masque la zone
      if (this.classList.contains('is-on') || this.rAF) this.hide();
      clearTimeout(this.idleTimer);
      var self = this;
      this.idleTimer = setTimeout(function () { self.onIdle(); }, IDLE_MS);
    }

    onIdle() {
      if (this.loading) return;
      if (!this.hasMore()) { this.hide(); return; }
      this.prefetchNext();                            // precharge en arriere-plan
      if (this.atBottom()) { this.hide(); return; }   // Regle 2
      if (this.lastVisible()) { this.show(); }        // Regle 1
      else { this.hide(); }
    }

    show() {
      if (this.classList.contains('is-on')) return;
      this.classList.add('is-on');
      this.startBar();
    }

    hide() {
      this.classList.remove('is-on');
      this.stopBar();
      this.setFill(0);
    }

    setFill(p) { if (this.fill) this.fill.style.width = p + '%'; }

    startBar() {
      this.stopBar();
      this.barStart = null;
      var self = this;
      var step = function (ts) {
        if (self.barStart == null) self.barStart = ts;
        var p = Math.min(1, (ts - self.barStart) / FILL_MS);
        self.setFill(p * 100);
        if (p < 1) { self.rAF = requestAnimationFrame(step); }
        else { self.rAF = null; self.loadMore(); }
      };
      this.rAF = requestAnimationFrame(step);
    }

    stopBar() { if (this.rAF) { cancelAnimationFrame(this.rAF); this.rAF = null; } }

    async loadMore() {
      if (this.loading || !this.hasMore()) return;
      this.loading = true;
      this.hide();
      var np = this.currentPage() + 1;
      var s = this.sig();
      var items;
      try {
        if (this.pf && this.pf.page === np && this.pf.sig === s) {
          items = await this.pf.promise;             // deja en memoire -> instantane
        } else {
          items = await this.fetchPage(np);          // fallback : fetch a la volee
        }
        this.pf = null;
        if (items && items.length && this.grid) {
          // apparition en cascade : fondu echelonne carte par carte (plus naturel)
          for (var k = 0; k < items.length; k++) {
            var el = items[k];
            if (el && el.classList) {
              el.classList.add('berry-lm-in');
              el.style.animationDelay = (k * 40) + 'ms';
              (function (node) {
                node.addEventListener('animationend', function () {
                  node.classList.remove('berry-lm-in');
                  node.style.animationDelay = '';
                }, { once: true });
              })(el);
            }
          }
          this.grid.append.apply(this.grid, items);
        }
        var clean = new URL(window.location.href);
        clean.searchParams.set('page', String(np));
        history.replaceState({}, '', clean.toString());
      } catch (e) {
        // silencieux : en cas d'echec la pagination numerotee reste disponible
      }
      this.loading = false;
      if (this.hasMore()) { this.prefetchNext(); }    // precharge deja la suivante
      else { this.remove(); }
    }
  }

  customElements.define('berry-load-more', BerryLoadMore);
})();
